import React, { useCallback, useState } from 'react';
import Button from '@mui/material/Button';
import Modal from '@/common/components/Modal/index';
import { useHistory } from 'react-router-dom';
import {
  DecedentMainInfo,
  PrimaryAccountUser,
} from '@/common/containers/Forms/index';
import { useStepperContext } from '@/common/hooks/index';
import styles from '@/common/styles/modal-form-primary.less';
import { routes } from '@/app/routing/index';
import Stepper from '@/common/components/Stepper/index';
import { useTranslation } from 'react-i18next';

const AddDecedent = ({ loading, open, onClose, addDecedent }) => {
  const { t } = useTranslation();
  const { nextStep, prevStep, currentStepInd } = useStepperContext();
  const history = useHistory();
  const [payload, setPayload] = useState({
    decedentData: {
      firstName: '',
      lastName: '',
      middleName: '',
      socialInsuranceNumber: '',
      localHealthNumber: '',
      dateOfBirth: '',
      countryOfBirth: 'Canada',
      cityOfBirth: '',
      provinceOfBirth: '',
      dateOfDeath: '',
      countryOfDeath: 'Canada',
      cityOfDeath: '',
      provinceOfDeath: '',
    },
    primaryUser: {
      email: '',
      firstName: '',
      lastName: '',
      middleName: '',
      mobilePhoneNumber: '',
      homePhoneNumber: '',
      role: 'executor',
    },
  });

  const saveDecedent = useCallback(
    (form) => {
      setPayload({ ...payload, decedentData: form });
      nextStep();
    },
    [payload]
  );

  const submitForm = useCallback(
    (form) => {
      const resPayload = {
        ...payload,
        primaryUser: { ...payload.primaryUser, ...form },
      };
      setPayload(resPayload);
      addDecedent(resPayload).then((decedent) => {
        history.push(`${routes.adminPanel.decedentProfile}${decedent.id}`);
      });
    },
    [payload]
  );

  return (
    <Modal className={styles.modal} open={open} overlay>
      <div className={styles.modalHeader}>
        <h3>{t('Add decedent account')}</h3>
      </div>
      <div className={styles.modalForm}>
        <div className={styles.modalBody}>
          <div className={styles.modalStepper}>
            <Stepper />
          </div>
          {currentStepInd > 0 ? (
            <PrimaryAccountUser
              initialValues={payload.primaryUser}
              onSubmit={submitForm}
              formId="addDecedent"
            />
          ) : (
            <DecedentMainInfo
              initialValues={payload.decedentData}
              onSubmit={saveDecedent}
              formId="addDecedent"
            />
          )}
        </div>
        <div className={styles.modalFooter}>
          {currentStepInd > 0 && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={prevStep}
              disabled={loading}
            >
              {t('Back')}
            </Button>
          )}
          <div className={styles.modalFooterBtns}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
              disabled={loading}
            >
              {t('Cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              loading={loading}
              form="addDecedent"
            >
              {currentStepInd > 0 ? t('Save') : t('Next')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddDecedent;
